import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react'

import { bootcampSanity } from '~/shared/sanity/bootcamp'

import { BootCampItemGroq } from '~/types/bootcamp'

import { AppLanguage } from '~/types/locale'

import { bootcampSplitApi } from './split.api'

const GetSubjectWithCourseList = bootcampSplitApi.injectEndpoints({
  endpoints: (build) => ({
    getBootcampSubjectWithCourses: build.query<
      BootCampItemGroq[],
      {
        language: AppLanguage
        gymCategory: string
      }
    >({
      queryFn: async (args) => {
        try {
          const data = await bootcampSanity.listSubjectsWithCourses(args)
          const { subjects } = data
          return {
            data: subjects,
          }
        } catch (error) {
          return {
            error: error as FetchBaseQueryError,
          }
        }
      },
      providesTags: (_, __, { gymCategory: id }) => [{ type: 'SubjectWithCourseList', id }],
    }),
  }),
  overrideExisting: false,
})

export const { useGetBootcampSubjectWithCoursesQuery } = GetSubjectWithCourseList
